import { render, staticRenderFns } from "./Journalelements.vue?vue&type=template&id=ea2794fa&scoped=true"
import script from "./Journalelements.vue?vue&type=script&lang=js"
export * from "./Journalelements.vue?vue&type=script&lang=js"
import style0 from "./Journalelements.vue?vue&type=style&index=0&id=ea2794fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2794fa",
  null
  
)

export default component.exports